import { Col, Modal, Button, FormGroup } from "react-bootstrap";
import React from "react";
import { Input, Row, Label, Container } from "reactstrap";

const BillMappingPopup = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header>
        <Modal.Title style={{ display: "flex", justifyContent: "start" }}>
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ marginTop: "10px" }}>
          {props.popupData &&
            props.popupData.map((data) => (
              <Row>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio2"
                      value={data.value}
                      onChange={(e) => {
                        props.setCategoryMap(e.target.value);
                        props.setButtonDisable(false);
                      }}
                    />
                    {data.label}
                  </Label>
                </FormGroup>
              </Row>
            ))}
          <Row style={{ display: "flex", justifyContent: "end" }}>
            <Button
              color="primary"
              disabled={props.buutonDiasble}
              onClick={props.close}
            >
              Map
            </Button>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default BillMappingPopup;
